import { Trans, useT } from '@clara/locale'
import { Stack, Typography } from '@mui/material'

const StepCard = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode
  title: string
  description: string
}) => {
  const { t } = useT('reimbursements')
  return (
    <Stack
      sx={(theme) => ({
        backgroundColor: theme.palette.common.white,
        borderRadius: 2,
        border: `1px solid ${theme.palette.v3.border.default}`,
        py: '27px',
        px: 2,
      })}
    >
      <Stack direction={'row'} spacing={2}>
        {/* <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: (theme) => theme.palette.v3.primary.active,
          }}
        >
          {icon}
        </Box> */}
        <Typography
          variant="body1"
          sx={(theme) => ({
            fontWeight: 600,
            color: theme.palette.v3.content.high_emphasis,
          })}
        >
          <Trans t={t} i18nKey={title} components={{ br: <br /> }} />
        </Typography>
      </Stack>
      <Typography
        variant="body2"
        sx={{
          mt: 2,
          color: (theme) => theme.palette.v3.content.medium_emphasis,
        }}
      >
        <Trans t={t} i18nKey={description} components={{ br: <br /> }} />
      </Typography>
    </Stack>
  )
}

export default StepCard
